<template>
    <div class="operatorBox">
        <public-header></public-header>
        <div class="height70"></div>
        <div class="box760 white-bg shadow fromBox">
            <h3 class="title">企业运营登录</h3>
            <el-form :model="form" :rules="rules" ref="ruleForm" class="demo-ruleForm">
                <el-form-item prop="mobile">
                    <el-input v-model.number="form.mobile" placeholder="请输入手机号码"></el-input>
                </el-form-item>
                <el-form-item class="relative" prop="mobile_code">
                    <el-button size="mini" type="warning" plain class="get-code absolute ff9203" :disabled="disabled" @click="sendCode" v-if="form.mobile">{{btnTxt}}</el-button>
                    <el-input v-model="form.mobile_code" placeholder="请输入验证码"></el-input>
                </el-form-item>
                <el-form-item>
<!--                    <el-button @click="resetForm('ruleForm')" style="width:195px;">取消登录</el-button>-->
                    <el-button type="primary" @click="operatorLogin('ruleForm')" style="width:100%;">立即登录</el-button>
                </el-form-item>
            </el-form>
        </div>
        <public-footer></public-footer>
        <back-top></back-top>
    </div>
</template>
<script>
    const checkPhone = (rule, value, callback) => {
        if (!value) {
            return callback(new Error('手机号不能为空'));
        } else {
            const reg = /^1[3|4|5|7|8|9][0-9]\d{8}$/;
            if (reg.test(value)) {
                callback();
            } else {
                return callback(new Error('请输入正确的手机号'));
            }
        }
    };
    import {
        sentSms,
        loginAccount
    } from '@/config/api.js'
    import PublicHeader from '@/components/PublicHeader'
    import PublicFooter from "@/components/PublicFooter.vue";
    import BackTop from "@/components/BackTop.vue";
    export default {
        name: 'Operator',
        components: {
            PublicHeader,
            PublicFooter,
            BackTop
        },
        data() {
            return {
                form: {
                    mobile: '',
                    mobile_code: ''
                },
                mobile: '',
                mobile_code: '',
                rules: {
                    mobile: [
                        {validator: checkPhone, trigger: 'blur'}
                    ],
                    mobile_code: [
                        { required: true, message: '请输入验证码'}
                    ]
                },
                auth_token: '',
                is_auth: null,
                is_pass: null,
                user_id: null,
                time:0,
                btnTxt:"获取验证码",
                disabled:false
            };
        },
        methods: {
            sendCode(){
                let reg=11 && /^((13|14|15|17|18|19)[0-9]{1}\d{8})$/;
                if(this.form.mobile === ''){
                    this.$message.error('请输入手机号码')
                }else if(!reg.test(this.form.mobile)){
                    this.$message.error('手机格式不正确');
                } else {
                    let data = {
                        mobile_phone:Number(this.form.mobile),
                        openid:this.$store.state.openid,
                    };
                    this.time=60;
                    this.disabled=true;
                    this.timer();
                    this.$post(sentSms,data)
                        .then(res => {
                            this.$message.success(res.msg)
                        })
                        .catch(err => {
                            this.$message.error(err.msg)
                        })
                }
            },
            timer(){
                if (this.time > 0) {
                    this.time--;
                    this.disabled=true;
                    this.btnTxt=this.time+"秒后重新获取验证码";
                    setTimeout(this.timer, 1000);
                }else {
                    this.time=0;
                    this.btnTxt="重新获取验证码";
                    this.disabled=false;
                }
            },
            operatorLogin(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        let data = {
                            user_type: 0,
                            web_openid: this.$store.state.openid,
                            unionid: this.$store.state.unionid,
                            mobile: this.form.mobile,
                            mobile_code: this.form.mobile_code
                        };
                        this.$post(loginAccount,data)
                            .then(res => {
                                // window.console.log(res);
                                this.auth_token = res.data.auth_token;
                                this.user_id = Number(res.data.user_id);
                                this.is_auth = Number(res.data.is_auth);
                                this.is_pass = Number(res.data.is_pass);
                                this.$store.commit('changeUserType',0);
                                this.$store.commit('changeAuthToken',this.auth_token);
                                this.$store.commit('changeId',this.user_id);
                                this.$store.commit('changeIsAuth',this.is_auth);
                                this.$store.commit('changeIsOperater',1);
                                this.$store.commit('changeRank',1);
                                this.$router.push('/enterprise/manage');
                                this.$message.success('登录成功');
                            })
                            .catch(err => {
                                this.$message.error(err.msg)
                            })
                    } else {
                        return false;
                    }
                });
            }
        }
    }
</script>
<style scoped>
    .fromBox{margin:100px auto;}
    .operatorBox{background-image: linear-gradient(45deg, #fe9539, #fed564);}
    .operatorBox .title{text-align: center;font-size: 18px;padding:30px;font-weight: normal;}
    .demo-ruleForm{width:400px;margin: 0 auto;display: block;padding:0 0 30px 0;}
    .get-code{z-index:9;right: 6px;top:6px;}
</style>
